<template>
  <div class="container">
    <div
      class="d-flex justify-center preview-container"
      :style="{ 'background-color': backgroundColor }"
      no-gutters
    >
      <img
        v-if="mediaType === 'image'"
        :src="proxiedMediaUrl"
        alt=""
        class="story-img"
      />
      <video
        v-if="mediaType === 'video'"
        class="story-video"
        v-bind:src="proxiedMediaUrl"
        preload="metadata"
        controls
      />
      <div
        class="story-title-container"
        :style="{
          top:
            titlePosition === 'top'
              ? '20%'
              : titlePosition === 'middle'
              ? '50%'
              : '80%',
        }"
      >
        <span
          class="text-subtitle-2 font-weight-bold white--text"
          :style="{ 'text-align': 'center' }">
          {{ title }}
        </span>
      </div>
      <div
        v-if="!mediaType"
        class="story-background"
        :style="{ 'background-color': backgroundColor }"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mediaType: String,
    media: String,
    titlePosition: String,
    title: String,
    backgroundColor: String,
  },
  computed: {
    proxiedMediaUrl() {
      console.log(process.env.NODE_ENV ,"process.env.NODE_ENV ");
      
      if (process.env.NODE_ENV === 'development') {
        // In local dev, use proxy to bypass CORS or COEP issues
        return `${process.env.VUE_APP_API_URL}/proxy/fetch?url=${encodeURIComponent(this.media)}`;
      } else {
        // In production, use the actual media URL
        return this.media;
      }
    }
  },
  methods: {},
};
</script>

<style scoped>
.container {
  width: 200px;
  padding: 10px 0px !important;
}
.preview-container {
  position: relative;
  min-height: 400px;
  padding-top: 177.78%;
}
.story-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 200px;
}
.story-title-container {
  position: absolute;
  background-color: #00000080;
  padding: 5px;
  display: flex;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.story-background {
  flex: 1;
}
.story-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  max-width: 200px;
}
</style>
